import { observer } from 'mobx-react-lite'
import { Card, Col, Container, Form, Row, Image, Modal } from 'react-bootstrap'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import FooterNew from '../components/Footer'
import { useStore } from '../../app/stores/store'
import EditPassword from './EditPassword'
import EditPhoneNumber from './EditPhoneNumber'
import EditFullName from './EditFullName'
import EditGender from './EditGender'
import Export from '../components/export/Export'
import EditAvatar from './EditAvatar'
import EditCompanyName from './EditCompanyName'
import './profile.scss'
import { Button } from '@mui/material'
import CloseAccount from './CloseAccount'

function Profile() {
  const { userStore } = useStore()
  const { getData, user } = userStore
  const INITIAL_VALUE = {
    fullName: false,
    phoneNumber: false,
    password: false,
    gender: false,
    avatar: false,
    company: false,
    delete: false,
  }
  const [edit, setEdit] = useState(INITIAL_VALUE)
  const { t } = useTranslation()

  const handleEdit = (field: any, value: any) => {
    setEdit((a) => ({
      ...a,
      [field]: value,
    }))
  }

  const genderOptions = Export()

  const genderLabel = genderOptions.find((gender) => gender.value === getData.gender)?.label

  function handleClose() {
    setEdit(INITIAL_VALUE)
  }

  const Inputs = [
    {
      label: t('full_name'),
      field: `${getData.firstName} ${getData.lastName}`,
      onClick: () => handleEdit('fullName', true),
    },
    {
      label: t('gender'),
      field: genderLabel,
      onClick: () => handleEdit('gender', true),
    },
    {
      label: t('email'),
      field: getData.email,
    },
    {
      label: t('password'),
      field: '**********',
      onClick: () => handleEdit('password', true),
    },
    {
      label: t('tel'),
      field: getData.phoneNumber !== null ? `+${getData.phoneNumber}` : '+' + '41',
      onClick: () => handleEdit('phoneNumber', true),
    },
    {
      label: 'Company Name',
      field: user?.companyName ? user.companyName : 'Not set',
      onClick: () => handleEdit('company', true),
    },
  ]

  const Modals = [
    {
      show: edit.fullName,
      onHide: () => handleEdit('fullName', false),
      component: <EditFullName handleClose={handleClose} />,
    },
    {
      show: edit.password,
      onHide: () => handleEdit('password', false),
      component: <EditPassword handleClose={handleClose} />,
    },
    {
      show: edit.phoneNumber,
      onHide: () => handleEdit('phoneNumber', false),
      component: <EditPhoneNumber handleClose={handleClose} />,
    },
    {
      show: edit.gender,
      onHide: () => handleEdit('gender', false),
      component: <EditGender handleClose={handleClose} />,
    },
    {
      show: edit.avatar,
      onHide: () => handleEdit('avatar', false),
      component: <EditAvatar handleClose={handleClose} />,
      size: true,
    },
    {
      show: edit.company,
      onHide: () => handleEdit('company', false),
      component: <EditCompanyName handleClose={handleClose} />,
    },
    {
      show: edit.delete,
      onHide: () => handleEdit('delete', false),
      component: <CloseAccount handleClose={handleClose} />,
      size: true,
    },
  ]

  return (
    <>
      <Container fluid className='card-center card-background'>
        <Card className='newFont prevent-select card-shadow login-card-size mt-5'>
          <Card.Header className='bg-white d-flex justify-content-between'>
            <h1 className='my-profile'>{t('my_profile')}</h1>
            <div className='image-container-profile'>
              <div className='overlay-profile'>
                <i onClick={() => handleEdit('avatar', true)} className='fa-solid fa-pencil' />
              </div>
              <Image
                className='profile-img-header img-header'
                src={
                  user!.avatarId
                    ? user!.avatar
                    : getData.gender === 1
                      ? '/images/avatar/avatar1.png'
                      : getData.gender === 0
                        ? '/images/avatar/avatar2.png'
                        : getData.gender === 2
                          ? '/images/avatar/avatar3.png'
                          : '/images/avatar/avatar1.png'
                }
              />
            </div>
          </Card.Header>
          <Card.Body className='card-padding'>
            <Form>
              <Form.Group className='mb-3 card-font-size test123'>
                <Row className='profile-hr'>
                  {Inputs.map((input, index) => (
                    <Col md={12} key={index}>
                      <Form.Label className='login-p'>{input.label}</Form.Label>
                      <div className='center-profile'>
                        <p>{input.field}</p>
                        {input.onClick && (
                          <button type='button' onClick={input.onClick} className='profile-button'>
                            <DriveFileRenameOutlineIcon /> {t('edit')}
                          </button>
                        )}
                      </div>
                    </Col>
                  ))}
                </Row>
              </Form.Group>
            </Form>
            <div className='profile-hr'>
              <Button onClick={() => handleEdit('delete', true)} variant='contained' color='error'>
                {t('close_account')}
              </Button>
            </div>
          </Card.Body>
        </Card>
        {/* Modals */}
        {Modals.map((modal, index) => (
          <Modal
            key={index}
            className={modal.size ? '' : 'fit-modal'}
            centered
            size={'lg'}
            show={modal.show}
            onHide={modal.onHide}
          >
            {modal.component}
          </Modal>
        ))}
      </Container>
      <FooterNew />
    </>
  )
}
export default observer(Profile)
